import { React } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { useLanguage } from '../../../Context/LanguageContext';

function LocationButton(props) {
  const { nowPage } = props;

  const history = useHistory();
  const { t } = useLanguage();

  return (
    <TopLevelWrapper>
      <Button isClicked={nowPage === 'Service'} onClick={() => history.push('/rule/service')}>{t('rules.nav.terms')}</Button>
      <Button isClicked={nowPage === 'Location'} onClick={() => history.push('/rule/location')}>{t('rules.nav.location')}</Button>
      <Button isClicked={nowPage === 'Privacy'} onClick={() => history.push('/rule/privacy')}>{t('rules.nav.privacy')}</Button>
      <Button isClicked={nowPage === 'Promotion'} onClick={() => history.push('/rule/promotion')}>{t('rules.nav.promotion')}</Button>
      <Button isClicked={nowPage === 'Refund'} onClick={() => history.push('/rule/refund')}>{t('rules.nav.refund')}</Button>
    </TopLevelWrapper>
  )
}

export default LocationButton;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 38px;
  margin-top: 38px;
`;

const Button = styled.div`
  display: flex;
  flex-direction: column;

  font-family: ${props => props.isClicked ? `NotoSansKR-Bold` : `NotoSansKR-Medium`};
  font-size: 16px;

  color: ${props => props.isClicked ? props.theme.text : props.theme.gray};

  padding-bottom: 7px;

  border-bottom: ${props => props.isClicked ? `2px solid ${props.theme.primary}` : `0px`};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;

    font-family: NotoSansKR-Bold;
    color: ${props => props.theme.text};

    border-bottom: 2px solid ${props => props.theme.primary};
  }
`;